module.exports = __webpack_public_path__ + "img/lm@2x.c04f8f4b.png";